import axios from '@/utils/http'
import Url from './requestUrl'

// 查询登录用户的企业实名信息
export function getRealname (params) {
  return axios({
    url: Url.getRealnameUrl,
    method: 'get',
    params
  })
}

// 人脸核验生成accesstoken
export function verificationGenerateToken (data) {
  return axios({
    url: Url.verificationGenerateTokenUrl,
    method: 'post',
    data
  })
}

// 人脸核验结果查询
export function verificationQuery (params) {
  return axios({
    url: Url.verificationQueryUrl,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/http/authentication.js